// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__aJnsH","content":"styles_content__1R54O"};